import { capitalize } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import { Link } from "react-router-dom";
import Spinner from "../Spinner";
import { formatDate } from "../../Helper/Helper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";
import { Modal, Button } from "react-bootstrap";


function CareerStaticPositionCard() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [careersData, setCareersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);


  useEffect(() => {
    window.scrollTo(0, 0);
    getCareerData();

    // const date = "2024-07-16 00:00:00";
  }, []);

  function isFutureDate(dateString) {
    const inputDate = new Date(dateString);
    const currentDate = new Date();

    currentDate.setHours(0, 0, 0, 0);

    return inputDate > currentDate;
  }

  const getCareerData = async () => {
    const response = await SendPostRequest("careers/jobs");
    setCareersData(response?.data);
    setLoading(false);
  };

  const handleMoreDetails = (job) => {
    setSelectedJob(job);
    setShowModal(true);
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Careers" Image="theme-2-banner-career.webp" />

        <section id="career-section" className="career-section py-5">
          <div class="offset-md-2 col-md-8 ">
            <div class="title-wrap text-center ">
              <div class="section-title margin-bottom-80">
                <h2 class="section-title mb-0 text-uppercase">
                  Available <span class="theme-color">Positions</span>
                </h2>
                <span class="section-border-bottom center"></span>
                {/* <p>
                  Offer a wide range of services to help businesses establish.
                </p> */}
              </div>
            </div>
          </div>
          <div className="container">
            {loading ? (
              <div className="text-center">
                <Spinner />
              </div>
            ) : careersData?.jobs?.length > 0 ? (
              <div className="row">
                {careersData.jobs.map((data, index) => (
                  <div className="col-lg-4 col-md-6 col-12 mb-4" key={index}>
                    <div
                      className="career-box-details pad-30 box-shadow bg-white b-radius-10 d-flex flex-column"
                      style={{ minHeight: "325px" }}
                    >
                      <div className="job-type text-uppercase mb-0 theme-color">
                        {data?.job_type}
                      </div>
                      <div className="job-title margin-bottom-10">
                        <h4>{data?.title}</h4>
                      </div>
                      <div className="job-description margin-bottom-20">
                        <p className="mb-0">
                          <strong>Experience: </strong>
                          {data?.experience}
                        </p>
                        <p className="mb-0">
                          <strong>Deadline: </strong>
                          {formatDate(data?.dead_line)}
                        </p>
                      </div>

                      {/* yahan pe margin-top: auto buttons ko neeche chipka dega */}
                      <div className="d-flex justify-content-center gap-3 mt-auto">
                        <div>
                          {isFutureDate(data?.published_at) ? (
                            <div className="apply-btn career-apply-btn">
                              <Link className="btn btn-default" title="Apply Now">
                                Coming Soon
                              </Link>
                            </div>
                          ) : (
                            <div className="apply-btn career-apply-btn">
                              <Link
                                 to={`/career/detail/${data?.uid}`}
                                className="btn btn-default"
                                title="Apply Now"
                              >
                                Apply Now
                              </Link>
                            </div>
                          )}
                        </div>
                        <div className="apply-btn career-apply-btn">
                          <Button
                            variant="default"
                            className="btn btn-default"
                            onClick={() => handleMoreDetails(data)}
                          >
                            More Details
                          </Button>
                        </div>
                      </div>
                    </div>

                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center">
                <p>
                  No available positions at the moment. Please check back later.
                </p>
              </div>
            )}
          </div>
        </section>

        <FooterWrapper />

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="md"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title className="career-job-modal-title">{selectedJob?.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="career-job-modal">
            {selectedJob && (
              <>
                {selectedJob?.content && (
                  <div className="mb-2">
                    <label className="fw-bold">Job Description:</label>
                    <div
                      dangerouslySetInnerHTML={{ __html: selectedJob?.content }}
                    />
                  </div>
                )}

                {selectedJob?.education && (
                  <p>
                    <strong>Education:</strong> {selectedJob?.education}
                  </p>
                )}
                {selectedJob?.experience && (
                  <p>
                    <strong>Experience:</strong> {selectedJob?.experience}
                  </p>
                )}
                {selectedJob?.languages && (
                  <p>
                    <strong>Languages:</strong> {selectedJob?.languages}
                  </p>
                )}
                {selectedJob?.segments && (
                  <p>
                    <strong>Department:</strong> {selectedJob?.segments}
                  </p>
                )}
                {selectedJob?.certifications && (
                  <p>
                    <strong>Certifications:</strong> {selectedJob?.certifications}
                  </p>
                )}
                {selectedJob?.dead_line && (
                  <p>
                    <strong>Deadline:</strong> {formatDate(selectedJob?.dead_line)}
                  </p>
                )}
                {selectedJob?.job_type && (
                  <p>
                    <strong>Job Type:</strong> {selectedJob?.job_type}
                  </p>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button

              className="btn btn-default"
              onClick={() => setShowModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default CareerStaticPositionCard;
